import axios from 'axios';
import { InteractionRequiredAuthError } from "@azure/msal-browser";
import { msalInstance } from '../index';
import { API_URL } from '../config';
import { loginRequest } from '../config/authConfig';
import { storeToken } from './auth';

const axiosInstance = axios.create({
  baseURL: API_URL,
});

axiosInstance.interceptors.request.use(async function (config) {

  const allActiveAccounts = msalInstance.getAllAccounts();

  const request = {
    ...loginRequest,
    account: allActiveAccounts.length === 0 ? null : allActiveAccounts[0],
  }

  const tokenResponse = await msalInstance.acquireTokenSilent(request).catch(err => {
    if (err instanceof InteractionRequiredAuthError) {
      // fallback to interaction when silent call fails
      return msalInstance.acquireTokenRedirect(request);
    } else {
        msalInstance.loginRedirect(loginRequest).catch(e => {
        console.error('Login ERROR: ', e);
      });
    }

  });
  storeToken(tokenResponse.accessToken);
  config.headers['Authorization'] = `Bearer ${tokenResponse.accessToken}`;

  return config;
}, function (error) {
  return Promise.reject(error);
});

export default axiosInstance;